import { austria, belgium, bulgaria, checkVAT, croatia, cyprus, czechRepublic, denmark, estonia, finland, france, germany, greece, hungary, ireland, italy, latvia, lithuania, luxembourg, malta, netherlands, poland, portugal, romania, slovakiaRepublic, slovenia, spain, sweden, } from 'jsvat';
export function isVAT(value) {
    return value
        ? checkVAT(value || '', [
            austria,
            belgium,
            bulgaria,
            croatia,
            cyprus,
            czechRepublic,
            denmark,
            estonia,
            finland,
            france,
            germany,
            greece,
            hungary,
            ireland,
            italy,
            latvia,
            lithuania,
            luxembourg,
            malta,
            netherlands,
            poland,
            portugal,
            romania,
            slovakiaRepublic,
            slovenia,
            spain,
            sweden,
        ]).isValid
        : true;
}
